import { CapaNotificationType } from '@generated/graphql';

const validTypes = [
  CapaNotificationType.PurchaseOrderRegisterRequest,
  CapaNotificationType.AwaitingPayment,
  CapaNotificationType.RejectRfqPurchaseOrderVirtualAccount,
  CapaNotificationType.RejectRfqPurchaseOrderCreditCard,
  CapaNotificationType.NotPaidCanceled,
  CapaNotificationType.CancelConfirmedCreditCard,
  CapaNotificationType.CancelConfirmedVirtualAccount,
  CapaNotificationType.StartProcessing,
  CapaNotificationType.RefundConfirmedVirtualAccount,
  CapaNotificationType.RefundConfirmedCreditCard,
  CapaNotificationType.StartShipping,
  CapaNotificationType.InduceConfirmPurchase,
  CapaNotificationType.PurchaseConfirmed
];

const refundTypes = [
  CapaNotificationType.RefundRequested, // 환불요청
  CapaNotificationType.RefundConfirmed, // 환불완료
  CapaNotificationType.CancelRequested, // 결제취소 요청
  CapaNotificationType.CancelConfirmedCreditCard,
  CapaNotificationType.CancelConfirmedVirtualAccount
];

export { validTypes, refundTypes };
